import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api/client';
import useSiteConfig, { PLACEHOLDER } from '../hooks/useSiteConfig';

const Contact = () => {
  const c = useSiteConfig();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: '', phone: '', email: '', interest: '', consent: false, website: '', ref: params.get('ref') || '' });
  const [state, setState] = useState({ status: 'idle', error: '' });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: 'sending', error: '' });
    try {
      await api.post('/api/leads/', form);
      setState({ status: 'done', error: '' });
    } catch (err) {
      const d = err.response?.data;
      const msg = err.response?.status === 429 ? 'Too many requests. Please try again later.'
        : (d && typeof d === 'object' && Object.values(d)[0]?.[0]) || 'Something went wrong. Please try again.';
      setState({ status: 'error', error: msg });
    }
  };

  const wa = c.whatsapp_number ? `https://wa.me/${c.whatsapp_number}?text=${encodeURIComponent('Hello, I would like to request an invite.')}` : null;
  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '4rem 1rem' }}>
      <h1>Contact us</h1>
      <p>Participation is by invitation. Reach out and our team will get back to you.</p>
      <h2>Request an invite</h2>
      {state.status === 'done' ? (
        <p role="status">Thank you. Our team will contact you shortly.</p>
      ) : (
        <form onSubmit={submit} style={{ display: 'grid', gap: '0.75rem', maxWidth: 480 }}>
          <label>Name<input required value={form.name} onChange={set('name')} className="input" autoComplete="name" /></label>
          <label>Mobile number<input required type="tel" value={form.phone} onChange={set('phone')} className="input" autoComplete="tel" /></label>
          <label>Email (optional)<input type="email" value={form.email} onChange={set('email')} className="input" autoComplete="email" /></label>
          <label>What are you interested in? (optional)<textarea value={form.interest} onChange={set('interest')} className="input" rows={3} /></label>
          {/* honeypot: hidden from people, filled by bots */}
          <input tabIndex={-1} aria-hidden="true" autoComplete="off" value={form.website} onChange={set('website')} style={{ position: 'absolute', left: '-9999px' }} name="website" />
          <label style={{ display: 'flex', gap: 8 }}>
            <input type="checkbox" checked={form.consent} onChange={set('consent')} required />
            <span>I agree to be contacted by call, message or WhatsApp about this enquiry.</span>
          </label>
          {state.status === 'error' && <p role="alert">{state.error}</p>}
          <button type="submit" className="btn-primary" disabled={state.status === 'sending'}>{state.status === 'sending' ? 'Sending…' : 'Request an invite'}</button>
        </form>
      )}
      <h2>Or reach us directly</h2>
      {wa ? (
        <p><a href={wa} className="btn-primary" style={{ display: 'inline-block', padding: '0.75rem 1.5rem' }}>Chat on WhatsApp</a></p>
      ) : (
        <p>WhatsApp number {PLACEHOLDER}</p>
      )}
      <h2>Details</h2>
      <ul>
        <li>Email: {c.support_email ? <a href={`mailto:${c.support_email}`}>{c.support_email}</a> : PLACEHOLDER}</li>
        <li>Phone: {c.support_phone ? <a href={`tel:${c.support_phone.replace(/\s/g, '')}`}>{c.support_phone}</a> : PLACEHOLDER}</li>
        <li>Operator: {c.operator_name || PLACEHOLDER}</li>
        <li>CIN: {c.operator_cin || PLACEHOLDER}</li>
        <li>Registered address: {c.operator_address || PLACEHOLDER}</li>
      </ul>
    </main>
  );
};

export default Contact;
